import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Video } from "Components";
import testDriveBanner from "Images/test-drive.jpg";

export const VideoChat = ({ videoId, chatId, ...props }) => {
  const [height, setHeight] = useState(0);

  const ref = useRef(null);

  useEffect(() => {
    if (ref) {
      setHeight(ref.current.clientHeight - 100);
    }
  }, [ref]);

  return (
    <>
      <VideoContainer ref={ref}>
        <Video id={videoId} />
        <VideoBannerAd src={testDriveBanner} />
      </VideoContainer>
      <ChatWindow
        src={`https://vimeo.com/event/${chatId}/chat/`}
        height="100%"
        frameborder="0"
        calcHeight={height}
      />
    </>
  );
};

const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const VideoBannerAd = styled.img`
  width: 100%;
  display: block;
`;

const ChatWindow = styled.iframe`
  display: flex;
  width: 100%;
  border: 0;
  height: ${(props) => props.calcHeight}px;

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    flex-direction: row;
    flex-shrink: 0;
    width: 392px;
    height: auto;
  }
`;
